import { parseISO, format as formatDate } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export default (date: string, format: string): string => {
  return formatDate(parseISO(date), format, {
    locale: ptBR,
  });
};
